// extracted by mini-css-extract-plugin
export default {"container":"OurStory_container__h0ujp"};